import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "ionic-angular";
import { TranslateModule } from "@ngx-translate/core";
import { CheckBoxListControlComponent } from "./check-box-list-control.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        CheckBoxListControlComponent
    ],
    exports: [
        CheckBoxListControlComponent
    ],
    entryComponents: [
        CheckBoxListControlComponent
    ]
})
export class CheckBoxListControlModule {
}



// WEBPACK FOOTER //
// ./src/vas/controls/check-box-list/form/check-box-list-control.module.ts